import { render, staticRenderFns } from "./DeedsList.vue?vue&type=template&id=edc7bd96&scoped=true&"
import script from "./DeedsList.vue?vue&type=script&lang=js&"
export * from "./DeedsList.vue?vue&type=script&lang=js&"
import style0 from "./DeedsList.vue?vue&type=style&index=0&id=edc7bd96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc7bd96",
  null
  
)

export default component.exports